<template>
  <div>
    <h3 class="home label-dark">
      {{ $t('component.registryCaseWizard.wizardFirstStep') }}
    </h3>
    <div class="mt-4">
      <b-row class="d-flex flex-column align-items-center">
        <b-col
          v-if="isExternalLabel"
          cols="10"
          class="text-left"
        >
          <div class="form-label">
            <label :class="{ requiredlabel: (firstStepHasErrors && !caseTree.label) }">
              {{ $t('component.registryCaseWizard.scanPrintLabel') }} *
            </label>
          </div>
          <div class="barcode-input component-inside-1 full-bordered">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input
                v-model="caseTree.label"
                class="form-control-sm"
                :class="{ requiredform: (firstStepHasErrors && !caseTree.label) }"
              />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="10"
          class="text-left mt-3"
        >
          <div class="form-label">
            <label :class="{ requiredlabel: (firstStepHasErrors && !caseTree.caseType) }">
              {{ $t('component.registryCaseWizard.caseType') }}*
            </label>
          </div>
          <vt-combo-select
            v-model="caseTree.caseType"
            qa="registry-wizard-case-type-select"
            class="nowrap"
            :options="caseTypes"
            label="descriptionInLaboratory"
            track-by="id"
            :allow-empty="false"
            :class="{ requiredform: (firstStepHasErrors && !caseTree.caseType) }"
            @input="$nextTick(() => { $emit('loadSampleTypes') })"
          />
        </b-col>
        <b-col
          cols="10"
          class="text-left mt-3"
        >
          <div class="form-label">
            <label :class="{ requiredlabel: (firstStepHasErrors && !caseTree.priority) }">
              {{ $t('component.registryCaseWizard.priority') }}*
            </label>
          </div>
          <vt-combo-select
            v-model="caseTree.priority"
            qa="registry-wizard-priority-select"
            class="nowrap"
            track-by="id"
            :options="priorities"
            label="name"
            :allow-empty="false"
            :class="{ requiredform: (firstStepHasErrors && !caseTree.priority) }"
          />
        </b-col>
        <b-col
          cols="10"
          class="mt-4 d-flex justify-content-end"
        >
          <b-button
            class="btn--primary"
            qa="registry-wizard-next-button"
            @click="$emit('goToSecondStep')"
          >
            {{ $t('component.registryCaseWizard.next') }}<i
              class="far fa-arrow-right ml-2"
              aria-hidden="true"
            />
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import sessionStore from '@/session/sessionStore'
import CommonCaseTypeServices from '@/api/resources/common/commonCaseTypeServices'

export default {
    name: 'RegistryWizardFirstStep',
    props: {
        caseTree: { type: Object },
        firstStepHasErrors: { type: Boolean },
        isExternalLabel: { type: Boolean }
    },
    data() {
        return {
            caseTypes: []
        }
    },
    computed: {
        priorities() {
            return sessionStore.state.priorities.filter(priority => priority.active)
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    created() {
        this.loadCaseTypes()
    },
    methods: {
        async loadCaseTypes() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(CommonCaseTypeServices.getActiveCaseTypesByLaboratory(this.labId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.caseTypes = response
        }
    }
}
</script>

<style scoped>

</style>
